import { render, staticRenderFns } from "./SelectBusiness.vue?vue&type=template&id=3a64358d&scoped=true&"
import script from "./SelectBusiness.vue?vue&type=script&lang=ts&"
export * from "./SelectBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBusiness.vue?vue&type=style&index=0&id=3a64358d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a64358d",
  null
  
)

export default component.exports